/**
 * Compact deterministic fingerprint for long stable-string payloads (cache keys).
 * FNV-1a 32-bit → 8 hex chars — not cryptographic.
 */
export function payloadKeyHash(input: string): string {
  let h = 2166136261
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i)
    h = Math.imul(h, 16777619)
  }
  return (h >>> 0).toString(16).padStart(8, "0")
}
